import { render, staticRenderFns } from "./ReportDashboard.vue?vue&type=template&id=4b57ba81&v-if=isLoggedIn&"
import script from "./ReportDashboard.vue?vue&type=script&lang=js&"
export * from "./ReportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports